import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/ClarityProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/ClientWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/GclidCapture.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/PageViewTracker.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["SplashProvider"] */ "/vercel/path0/app/context/SplashContext.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/PixelTracker.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
